import { type Session } from "@src/appV2/Auth/types";
import { logEvent } from "@src/appV2/lib/analytics";
import { HCF_USER_EVENTS } from "@src/constants/analyticsEvents";
import { createPath, type Location } from "history";

export function logSidebarMenuItemClicked(params: {
  menuItemName: string;
  session: Session;
  previousLocation: Location;
}) {
  const { menuItemName, session, previousLocation } = params;

  logEvent(HCF_USER_EVENTS.SIDEBAR_MENU_ITEM_CLICKED, {
    menuItemName,
    workplaceId: session.profile?.userId,
    workplaceUserId: session.user?._id,
    previousPath: createPath(previousLocation),
    sidebarVariant: "redesigned",
  });
}
